export default __webpack_public_path__ + "static/media/play_with_water.b7d6f718.jpg";